<template>
  <div>
    <h2>图层类型</h2>
    <p>默认类型是 popover， 可选 text。</p>
    <h3>popover 气泡</h3>
    <demo>
      <vue-form :model="form" :layer="layer">
        <vue-form-line :cols="[{ span: 12, label: '商品名称', prop: '/form/name' }]">
          <el-input v-model="form.name" placeholder="请输入名称" />
        </vue-form-line>
        <vue-form-line :cols="[{ span: 12, label: '商品类型', prop: '/form/type' }]">
          <el-input v-model="form.name" placeholder="请输入商品类型" />
        </vue-form-line>
      </vue-form>
      <div slot="description">
        <p>图层作用于 prop 指定的元素</p>
      </div>
      <div slot="meta">
        <pre><code class="hljs hl-html"><span class="hljs-tag">&lt;vue-form :model=<span class="hljs-string">"form"</span> :layer=<span class="hljs-string">"layer"</span>&gt;
    &lt;vue-form-line :cols=<span class="hljs-string">"[{ span: 12, label: '商品名称', prop: '/form/name' }]"</span>&gt;
      &lt;el-input v-model=<span class="hljs-string">"form.popover"</span> placeholder=<span class="hljs-string">"请输入商品名称"</span> /&gt;
    &lt;/vue-form-line&gt;
  &lt;/vue-form&gt;
  &lt;script&gt;
  export default <span class="hljs-attr">{
    data() {
      <span class="hljs-tag">return</span> {
        form: {
          name: "",
          type: ""
        },
        layer: [
          {
            data: [
              {
                prop: "/form/name",
                data: "商品名称"
              },
              {
                prop: "/form/type",
                data: "商品类型",
                type: "text"
              }
            ]
          }
        ]
      }
    }
  }</span>
  &lt;/script&gt;</span></code></pre>
      </div>
    </demo>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        type: ""
      },
      layer: [
        {
          data: [
            {
              prop: "/form/name",
              data: "商品名称"
            },
            {
              prop: "/form/type",
              data: "商品类型",
              type: "text"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/layer/type.vue